import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { get } from 'lodash';
import { IHeaderParams } from 'ag-grid-community';
import { IHeaderAngularComp } from 'ag-grid-angular';
@Component({
  selector: 'xea-popover-header-cell',
  templateUrl: 'popover-header-cell-render.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class XEAPopoverHeaderCellRendererComponent implements IHeaderAngularComp {
  @ViewChild('divElement', { static: false }) public divElement: ElementRef;

  public params: IHeaderParams;
  public popoverText: string;
  public headerClass: string;
  public position: string;
  public iconClass: string;
  public alwaysShowPopover: boolean;
  public popoverParentNode: string = 'dm-grid';

  public agInit(params: IHeaderParams): void {
    this.params = params;
    this.popoverText = get(this.params, 'popoverText', '');
    this.iconClass = get(this.params, 'iconClass', '');
    this.headerClass = get(this.params, 'headerClass', 'header-text-box');
    this.position = get(this.params, 'position', 'bottom');
    this.alwaysShowPopover = get(this.params, 'alwaysShowPopover', true);
    this.popoverParentNode = get(this.params, 'popoverParentNode', this.popoverParentNode);
  }

  public refresh(): boolean {
    return false;
  }
}
